import { render, staticRenderFns } from "./textTitle3.vue?vue&type=template&id=56a571a2&scoped=true"
import script from "./textTitle3.vue?vue&type=script&lang=js"
export * from "./textTitle3.vue?vue&type=script&lang=js"
import style0 from "./textTitle3.vue?vue&type=style&index=0&id=56a571a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a571a2",
  null
  
)

export default component.exports